<template>
  <div v-if="loading.Data" class="d-flex flex-column h-100">
    <spinner-loading></spinner-loading>
  </div>
  <div v-else id="dashborad-table-chart" class="py-2 pr-2 h-100">
    <div class="pl-3">
      <div class="d-flex flex-column h-100">
        <div class="card-content-title-wrp">
          <div class="d-flex justify-content-between">
            <div class="card-content-title">
              <div class="content-name">
                {{
                  renderData.jsonOverride.Left_Title
                    ? renderData.jsonOverride.Left_Title
                    : config.config.left_title
                }}
              </div>
              <div
                class="content-value"
                v-if="
                  renderData.jsonOverride.Button_Left_Title ||
                  config.config.button_left_title
                "
              >
                <span>
                  {{
                    renderData.jsonOverride.Button_Left_Title
                      ? renderData.jsonOverride.Button_Left_Title
                      : config.config.button_left_title
                  }}</span
                >
                <span> คำตอบ</span>
              </div>
            </div>

            <div
              class="content-type d-flex justify-content-end"
              v-if="
                renderData.jsonOverride.Right_Title || config.config.right_title
              "
            >
              <div class="d-flex justify-content-between content-type-wrp">
                <div
                  :class="
                    layoutData.module_name == 'SurveyDashboard'
                      ? 'border-type'
                      : ''
                  "
                >
                  Type :
                </div>
                <div class="d-flex ml-2">
                  <div class="mr-1 icon-type-svg">
                    <component
                      :is="
                        resovleIcon(
                          renderData.jsonOverride.Right_Title
                            ? renderData.jsonOverride.Right_Title
                            : config.config.right_title
                        )
                      "
                      class="mr-2"
                    />
                  </div>
                  <div>
                    {{
                      renderData.jsonOverride.Right_Title
                        ? renderData.jsonOverride.Right_Title
                        : config.config.right_title
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="content-title"
          v-if="layoutData.module_name == 'QuizDashboard'"
        >
          จำนวนลูกค้าทั้งหมด
        </div>
        <div v-if="renderData.RenderTableFields.length > 0">
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <b-table
                :items="renderData.data"
                :fields="renderData.RenderTableFields"
                responsive
                bordered
                borderless
                show-empty
                no-local-sorting
                class="dynamic-table pr-1"
                :tbody-tr-class="rowClass"
                :class="renderData.data ? 'b-table-sticky-header' : ''"
              >
                <template
                  v-for="col in renderData.RenderTableFields"
                  v-slot:[renderHead(col.key)]
                >
                  <span
                    :key="col.key + 'head'"
                    class="d-flex justify-content-around data-table-header"
                  >
                    {{ col.label }}</span
                  >
                </template>

                <template
                  v-for="col in renderData.RenderTableFields"
                  v-slot:[renderCell(col.key)]="data"
                >
                  <div
                    :key="col.key + data.value + 'image'"
                    class="d-flex justify-content-center"
                  >
                    <b-img
                      v-if="col.key == 'image'"
                      :src="data.value || NoPicture"
                      class="d-flex justify-content-around data-table-col-img"
                    />
                  </div>
                  <div
                    v-if="resolveNotShowText(col.key, data.value)"
                    :key="col.key + 'value'"
                    class="d-flex justify-content-around data-table-col-text"
                  >
                    {{ data.value }}
                  </div>
                </template>

                <template #table-busy>
                  <overlay-loading :loading="true" />
                </template>
                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" :height="100" />
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </div>
        <div v-else class="content-body-card h-100">
          <card-no-item :textNoImg="'Item Not Found'" :height="100" />
        </div>
        <div class="legend-wrp mb-1">
          <div v-for="item in renderData.legend" :key="item.title">
            <b-row>
              <b-col>
                <div class="d-flex align-items-center ml-3">
                  <div
                    class="legend-radius-color"
                    :style="{ backgroundColor: item.color }"
                  />
                  <div class="legend-title">
                    {{ item.title }}
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  watch,
  reactive,
  onMounted,
  getCurrentInstance,
  onBeforeMount,
  computed,
} from "@vue/composition-api";
import router from "@/router";
import store from "@/store";

import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";
import NoPicture from "@/assets/images/icons/nopicture.png";
import SingleChoiceSvg from "@/@core/components/svg/question-modal/SingleChoice.vue";
import MultipleChoiceSvg from "@/@core/components/svg/survey/MultipleChoice.vue";
import TextAreaSvg from "@/@core/components/svg/survey/TextArea.vue";
import DateSvg from "@/@core/components/svg/survey/Date.vue";
import DropdownSvg from "@/@core/components/svg/survey/Dropdown.vue";

import quizListModel from "@/models/survey-quiz/quiz-list";
import surveyModel from "@/models/survey-quiz/survey";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";

export default {
  props: {
    config: { default: {} },
    layoutData: { default: {} },
    data: { default: {} },
  },
  components: {
    CardNoItem,
    SingleChoiceSvg,
    MultipleChoiceSvg,
    TextAreaSvg,
    DateSvg,
    DropdownSvg,
  },
  setup(props) {
    const { fetchQueryDataDashboard } = quizListModel();

    const { fetchQueryDataDashboard: fetchQueryDataSurveyDashboard } =
      surveyModel();

    const { openDefaultErrorModal } = useValidationModal();

    const loading = reactive({
      tableData: false,
    });

    const renderData = reactive({
      data: [],
      legend: [],
      jsonOverride: {},
      RenderTableFields: [],
    });

    const renderCell = (key) => `cell(${key})`;

    const renderHead = (key) => `head(${key})`;

    const rowClass = (item, type) => {
      if (item.is_correct == "True") {
        return "teble-collect";
      }
    };

    const resolveNotShowText = (key, data) => {
      if (key == "image") {
        return false;
      } else {
        return true;
      }
    };

    const formData = reactive({
      groupId: "",
      moduleName: "",
    });

    const MODULENAME = reactive({
      QUIZ: "QuizDashboard",
      SURVEY: "SurveyDashboard",
    });

    const resolveChartModule = (moduleName, GroupId) => {
      switch (moduleName) {
        case MODULENAME.QUIZ:
          fetchDashboradDetail(GroupId);
          return;
        case MODULENAME.SURVEY:
          fetchDashboradSurveyDetail(GroupId);
          return;
      }
    };

    const fetchDashboradDetail = (GoupId) => {
      loading.Data = false;

      const payload = {
        CardId: props.config.id,
        Quiz_GroupId: GoupId,
        QuestionId: props.config.payload.query_data.id,
        Key: props.config.payload.query_data.key,
      };

      fetchQueryDataDashboard.payload = payload;

      store
        .dispatch("api/apiRequest", fetchQueryDataDashboard)
        .then((response) => {
          renderData.data = response.data.list;
          renderData.jsonOverride = JSON.parse(response.data.jsonoverride);

          if (renderData.jsonOverride.header_seq.length > 0) {
            renderData.jsonOverride.header_seq.map((o, index) => {
              let splitKeyHeader = o.split(".");

              let keyHeaderTable = splitKeyHeader[1];

              renderData.RenderTableFields.push({
                seq: index,
                key: keyHeaderTable,
              });

              Object.entries(
                renderData.jsonOverride.header_name_mapping
              ).forEach(([key, value]) => {
                renderData.RenderTableFields.map((e) => {
                  let splitKeyLabel = key.split(".");

                  let keyTableLabel = splitKeyLabel[1];
                  if (e.key == keyTableLabel) {
                    e.label = value;
                  }
                });
              });

              Object.entries(renderData.jsonOverride.data_type_mapping).forEach(
                ([key, value]) => {
                  renderData.RenderTableFields.map((e) => {
                    if (e.key == key) {
                      e.type = value;
                    }
                  });
                }
              );
            });
          } else if (props.config.config.header_seq.length > 0) {
            props.config.config.header_seq.map((o, index) => {
              let splitKeyHeader = o.split(".");

              let keyHeaderTable = splitKeyHeader[1];

              renderData.RenderTableFields.push({
                seq: index,
                key: keyHeaderTable,
              });

              Object.entries(props.config.config.header_name_mapping).forEach(
                ([key, value]) => {
                  let splitKeyLabel = key.split(".");

                  let keyTableLabel = splitKeyLabel[1];

                  renderData.RenderTableFields.map((e) => {
                    if (e.key == keyTableLabel) {
                      e.label = value;
                    }
                  });
                }
              );

              Object.entries(props.config.config.data_type_mapping).forEach(
                ([key, value]) => {
                  renderData.RenderTableFields.map((e) => {
                    if (e.key == key) {
                      e.type = value;
                    }
                  });
                }
              );
            });
          }

          renderData.legend = [
            {
              title: "ถูก",
              color: "#67AD5B",
            },
            {
              title: "ผิด",
              color: "#C6C6C6",
            },
          ];
        })
        .catch((error) => {
          openDefaultErrorModal(error);
        })
        .finally(() => {
          loading.Data = false;
        });
    };

    const fetchDashboradSurveyDetail = (GoupId) => {
      loading.Data = false;

      const payload = {
        CardId: props.config.id,
        Survey_GroupId: GoupId,
        QuestionId: props.config.payload.query_data.id,
        Key: props.config.payload.query_data.key,
      };

      fetchQueryDataSurveyDashboard.payload = payload;

      store
        .dispatch("api/apiRequest", fetchQueryDataSurveyDashboard)
        .then((response) => {
          renderData.data = response.data.list;
          renderData.jsonOverride = JSON.parse(response.data.jsonoverride);

          if (renderData.jsonOverride.header_seq.length > 0) {
            renderData.jsonOverride.header_seq.map((o, index) => {
              renderData.RenderTableFields.push({
                seq: index,
                key: o,
              });

              Object.entries(
                renderData.jsonOverride.header_name_mapping
              ).forEach(([key, value]) => {
                renderData.RenderTableFields.map((e) => {
                  let splitKeyLabel = key.split(".");

                  let keyTableLabel = splitKeyLabel[0];

                  if (e.key == keyTableLabel) {
                    e.label = keyTableLabel;
                  }
                });
              });

              Object.entries(renderData.jsonOverride.data_type_mapping).forEach(
                ([key, value]) => {
                  renderData.RenderTableFields.map((e) => {
                    if (e.key == key) {
                      e.type = value;
                    }
                  });
                }
              );
            });
          } else if (props.config.config.header_seq.length > 0) {
            props.config.config.header_seq.map((o, index) => {
              renderData.RenderTableFields.push({
                seq: index,
                key: o,
              });

              Object.entries(props.config.config.header_name_mapping).forEach(
                ([key, value]) => {
                  let splitKeyLabel = key.split(".");

                  let keyTableLabel = splitKeyLabel[0];

                  renderData.RenderTableFields.map((e) => {
                    if (e.key == keyTableLabel) {
                      e.label = value;
                    }
                  });
                }
              );

              Object.entries(props.config.config.data_type_mapping).forEach(
                ([key, value]) => {
                  renderData.RenderTableFields.map((e) => {
                    if (e.key == key) {
                      e.type = value;
                    }
                  });
                }
              );
            });
          }
        })
        .catch((error) => {
          openDefaultErrorModal(error);
        })
        .finally(() => {
          loading.Data = false;
        });
    };

    const resovleIcon = (iconName) => {
      switch (iconName) {
        case "Single Choice":
          return "SingleChoiceSvg";
        case "Multiple Choice":
          return "MultipleChoiceSvg";
        case "Dropdown":
          return "DropdownSvg";
        case "Date":
          return "DateSvg";
        case "Text Area":
          return "TextAreaSvg";
      }
    };

    onBeforeMount(() => {
      formData.groupId = parseInt(router.currentRoute.params.ref);
      formData.moduleName = props.layoutData.module_name;

      resolveChartModule(formData.moduleName, formData.groupId);
    });

    return {
      loading,
      renderHead,
      renderCell,
      renderData,
      rowClass,
      resolveNotShowText,
      NoPicture,
      resovleIcon,
    };
  },
};
</script>


<style>
@import "~@/assets/css/pages/dynamic-tables.css";
#dashborad-table-chart .teble-collect {
  background-color: #dfeedd !important;
  color: #000 !important;
}

#dashborad-table-chart .table {
  color: #000 !important;
}

#dashborad-table-chart .dynamic-table th {
  background: #faf8fa !important;
  font-size: 18px;
}

#dashborad-table-chart .dynamic-table td {
  border-top: 1px solid #e2e2e2;
  padding: 8px;
  font-size: 18px;
}

#dashborad-table-chart .icon-type-svg > svg {
  fill: #a2a2a2 !important;
  stroke: #a2a2a2 !important;
  width: 15px !important;
  height: 15px !important;
  margin-bottom: 1px;
}

#dashborad-table-chart g#Rectangle_11537 {
  stroke: #a2a2a2 !important;
}

#dashborad-table-chart .b-table-sticky-header {
  overflow-y: auto;
  max-height: 250px;
}

#dashborad-table-chart .dynamic-table::-webkit-scrollbar {
  height: 15px;
  width: 4px;
}

#dashborad-table-chart .dynamic-table::after {
  content: "";
  position: absolute;
  z-index: -1;
  height: calc(100% - 20px);
  top: 10px;
  right: -1px;
  width: 5px;
  background: #666;
}
</style>

<style scoped>
#dashborad-table-chart .dynamic-table {
  min-height: 100% !important;
  width: 100% !important;
  border-collapse: collapse !important;
}

#dashborad-table-chart .data-table-col-img {
  height: 40px;
}

#dashborad-table-chart .card-content-title-wrp {
  min-height: 70px;
}

#dashborad-table-chart .content-name {
  text-align: left;
  font-size: 21px;
  font-weight: bold;
  color: rgb(0, 0, 0);
}

#dashborad-table-chart .content-value {
  font-size: 18px;
  padding-left: 16px;
  color: #707070;
}

#dashborad-table-chart .content-title {
  text-align: left;
  font-size: 21px;
  font-weight: bold;
  color: rgb(0, 0, 0);
  padding-left: 16px;
}

#dashborad-table-chart .content-type {
  font-size: 18px;
  color: #707070;
}

#dashborad-table-chart .content-type-wrp {
  width: 163px;
}

#dashborad-table-chart .legend-wrp {
  position: absolute;
  bottom: 0;
  right: 44%;
  display: flex;
}

#dashborad-table-chart .legend-radius-color {
  margin-right: 10px;
  border-radius: 4px;
  width: 12px;
  height: 12px;
}

#dashborad-table-chart .legend-title {
  font-size: 18px;
  color: #000;
}

#dashborad-table-chart .overflow-wrp {
  overflow-y: scroll;
  max-height: 250px;
}

#dashborad-table-chart .border-type {
  border-left: 1.5px solid #a2a2a2;
  height: 30px;
  padding-left: 10px;
}
</style>
